import { Globe } from 'lucide-react'

import { getFaviconUrl } from '@/lib/file/favicon-utils'
import { cn } from '@/lib/ui/style-helpers'

type WebsiteFaviconProps = {
  websiteUrl?: string
  className?: string
}
export const WebsiteFavicon = ({ websiteUrl, className }: WebsiteFaviconProps) => {
  if (websiteUrl) {
    return (
      <object
        type='image/x-icon'
        data={getFaviconUrl(websiteUrl)}
        className={cn('size-6', className)}
      >
        <Globe className={cn('text-main-foreground-placeholder', className)} />
      </object>
    )
  }
  return <Globe className={cn('text-main-foreground-placeholder', className)} />
}
